module.exports = __webpack_public_path__ + "img/menu-expanded.7929456c.svg";